export const QUERIES = {
  EMAIL: 'email',
  CREATE_EMAIL: 'create_email',
} as const

export const emailKeys = {
  byId: (id: string) => [QUERIES.EMAIL, id] as const,
  createEmail: () => [QUERIES.CREATE_EMAIL] as const,
}
